import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0977c06d"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTransitionElements: require('/vercel/path0/components/page/TransitionElements.vue').default,PageCookie: require('/vercel/path0/components/page/Cookie.vue').default})
